import React from "react";
import ReactDOM from "react-dom";
import "materialize-css/dist/css/materialize.min.css";
import "materialize-css/dist/js/materialize.min.js";
import App from "./App";
import "./index.css";

ReactDOM.render(<App />, document.getElementById("root"));
